<ng-container *ngIf="artistFormArr" [formGroup]="parentForm">
  <div formArrayName="artists" class="form-group">
    <div class="row gy-2">
      <ng-container *ngFor="let artistControl of artistFormArr.controls; let i = index;">
        <div [formGroupName]="i" class="col-md-6">
          <div class="d-flex">
            <vg-auto-input
              [ngStyle]="{width: '70%'}"
              [formControl]="$any(artistControl)"
              [modelToTextMapper]="modelToTextMapper"
              [modelToImgSrcMapper]="modelToImgSrcMapper"
              [searchResults]="uploadData.filteredArtists"
              [placeholder]="'feature.artist.type_to_search' | translate"
              (changeTextEvent)="suggestArtist($event)"
            ></vg-auto-input>
            <div class="d-flex justify-content-center" style="width: auto">
              <button type="button" class="btn btn-info rounded-lg mx-1" style="min-width: 2rem" (click)="addArtist()">+</button>
              <button
                type="button"
                class="btn btn-danger rounded-lg mx-1"
                style="min-width: 2rem"
                (click)="removeArtist(i)"
                *ngIf="artistFormArr.controls.length > 1"
              >
                -
              </button>
            </div>
          </div>
          <vg-error-section [label]="'feature.artist.artist_name' | translate" [control]="artistControl"></vg-error-section>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>
